"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _immutable = require("immutable");

var _QueuesMediator = require("crm_ui/queues/QueuesMediator");

var _ImmutableEngagementModel = require("customer-data-objects/model/ImmutableEngagementModel");

function _default(tasks, activeTaskId) {
  return tasks.reduce(function (acc, task) {
    if (!task) {
      return acc;
    } // we dont want to exclude the active task


    if (String((0, _ImmutableEngagementModel.getId)(task)) === activeTaskId && (0, _QueuesMediator.taskHasValidAssociation)(task)) {
      return acc.push(task);
    }

    if (!(0, _QueuesMediator.taskIsValid)(task)) {
      return acc;
    }

    return acc.push(task);
  }, (0, _immutable.List)());
}

module.exports = exports.default;